  // assets\grid.js

var category_view = {
    'initView' : function (type, cols, element) {
        category_view.changeView(type, cols, element);
    },

    // sm/xs columns come from theme settings via snippets/grid-col-class (data-cf-col-class);
    // the view switcher only picks lg/md. Fallback keeps the old classes if the attribute is missing.
    'smallCols' : function (fallback) {
        var wrap = document.querySelector('.custom-category');
        var m = ((wrap && wrap.getAttribute('data-cf-col-class')) || '').match(/\bcol-(?:sm|xs)-\d+\b/g);
        return m && m.length ? m.join(' ') : fallback;
    },

    'changeView' : function (type, cols, element) {
        if(type == "grid") {
            var column = parseInt(cols);
            if(column == 2) {
                $('#content .product-item').attr('class', 'product-layout product-grid grid-entrance module-style1 col-lg-6 col-md-6 ' + category_view.smallCols('col-sm-6 col-xs-6') + ' product-item');
            }
            if(column == 3) {
                $('#content .product-item').attr('class', 'product-layout product-grid grid-entrance module-style1 col-lg-4 col-md-4 ' + category_view.smallCols('col-sm-4 col-xs-4') + ' product-item');
            }
            if(column == 4) {
                $('#content .product-item').attr('class', 'product-layout product-grid grid-entrance module-style1 col-lg-3 col-md-3 ' + category_view.smallCols('col-sm-6 col-xs-6') + ' product-item');
            }
            if(column == 5) {
                $('#content .product-item').attr('class', 'product-layout product-grid grid-entrance module-style1 col-lg-divide-5 col-md-divide-5 ' + category_view.smallCols('col-sm-6 col-xs-6') + ' product-item');
            }
			
			category_view.customPriceBoxGrid();
        }

        if(type == "list") {
            $('#content .product-item').attr('class', 'product-layout product-list col-xs-12 product-item');
			
			category_view.customPriceBoxList();
        }

        $('.btn-custom-view').removeClass('active');
        $('.' + element).addClass('active');

        localStorage.setItem('type', type);
        localStorage.setItem('cols', cols);
        localStorage.setItem('element', element);
        localStorage.setItem('viewContext', $('#category-view-context').val());
    },
	
	'customPriceBoxList' : function() {
		$(".product-item .item").each(function() {
			var action_link = $(this).find('.action-links');
			$(this).find('.price-box').prependTo(action_link);
		});
	},
	
	'customPriceBoxGrid' : function() {
		$(".product-item .item").each(function() {
			var caption = $(this).find('.caption');
			$(this).find('.price-box').appendTo(caption);
			$(this).find('.box-hover').appendTo(caption);
		});
	}
}

category_view.restoreLayout = function () {
    if (!$('#category-view-type').length) return;

    var context = $('#category-view-context').val();
    var storedContext = localStorage.getItem('viewContext');
    var storedType = localStorage.getItem('type');

    $('#content').addClass('no-transition');

    if (storedContext === context && storedType && storedType !== 'none') {
        var cols = localStorage.getItem('cols');
        var element = localStorage.getItem('element');
        category_view.initView(storedType, cols, element);
        if (storedType === 'list') {
            category_view.customPriceBoxList();
        } else {
            category_view.customPriceBoxGrid();
        }
    } else {
        var type = $('#category-view-type').val();
        var cols = $('#category-grid-cols').val();
        if (type == 'grid') {
            category_view.initView(type, cols, 'btn-grid-' + cols);
            category_view.customPriceBoxGrid();
        }
        if (type == 'list') {
            category_view.initView(type, cols, 'btn-list');
            category_view.customPriceBoxList();
        }
    }

    void document.body.offsetHeight;

    requestAnimationFrame(function () {
        $('#content').removeClass('no-transition');
    });
};

category_view.afterGridHtmlChanged = function (replayEntrance) {
    category_view.restoreLayout();
    if (window.ImageSkeleton) {
        ImageSkeleton.init('#custom-products');
        ImageSkeleton.init('[data-collection-banner]');
    }
    if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.checkElems === 'function') {
        lazySizes.loader.checkElems();
    }
    if (replayEntrance || !$('body').hasClass('grid-loaded')) {
        $(document).trigger('grid:changed');
    } else {
        $(document).trigger('grid:refreshed');
    }
};

$(document).on('click', '#grid-view', function() {
    var cols = $('#category-grid-cols').val();
    category_view.changeView('grid', cols, 'btn-grid-' + cols);
    category_view.customPriceBoxGrid();
});

$(document).on('click', '#list-view', function() {
    var cols = $('#category-grid-cols').val();
    category_view.changeView('list', cols, 'btn-list');
    category_view.customPriceBoxList();
});

$(document).ready(function () {
    category_view.restoreLayout();
});

document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || typeof event.target.querySelector !== 'function') return;
    if (!event.target.querySelector('#custom-products, #category-view-type')) return;
    category_view.afterGridHtmlChanged(false);
});